import defaultTheme from 'windicss/defaultTheme';

export const colors: Record<string, Record<number, string>> = {
	...defaultTheme.colors,
	gray: {
		50: '#f9fafb',
		100: '#eaeaeb',
		200: '#cacbcd',
		300: '#a7a9ac',
		400: '#696c71',
		500: '#282d34',
		600: '#24292f',
		700: '#181b20',
		800: '#121518',
		900: '#0c0e10',
	},
	primary: {
		50: '#EDE7F6',
		100: '#D1C4E9',
		200: '#B39DDB',
		300: '#9575CD',
		400: '#7E57C2',
		500: '#673AB7',
		600: '#5E35B1',
		700: '#512DA8',
		800: '#4527A0',
		900: '#311B92',
	},
};
